// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__VACfS","close":"Modal_close__Yp33c","wrapper":"Modal_wrapper__V5jEQ"};